import React from 'react';
import { Icon } from '@iconify/react';

const StepIndicator = ({ current, steps }) => (
    <div className="flex items-center justify-center gap-2 mb-8">
        {steps.map((step, i) => (
            <React.Fragment key={step}>
                <div className="flex items-center gap-2">
                    <div
                        className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition-all duration-300 ${i <= current
                            ? 'bg-lime-500 text-black shadow-lg shadow-lime-500/30'
                            : 'bg-slate-200 dark:bg-store-gray-dark text-slate-400 dark:text-store-gray'
                            }`}
                    >
                        {i < current ? (
                            <Icon icon="solar:check-circle-bold" className="text-base" />
                        ) : (
                            i + 1
                        )}
                    </div>
                    <span
                        className={`text-xs font-medium hidden sm:inline ${i <= current
                            ? 'text-slate-900 dark:text-white'
                            : 'text-slate-400 dark:text-store-gray'
                            }`}
                    >
                        {step}
                    </span>
                </div>
                {i < steps.length - 1 && (
                    <div
                        className={`w-8 sm:w-12 h-0.5 rounded transition-colors ${i < current
                            ? 'bg-lime-500'
                            : 'bg-slate-200 dark:bg-store-gray-dark'
                            }`}
                    />
                )}
            </React.Fragment>
        ))}
    </div>
);

export default StepIndicator;
